import { VStack } from "flicket-ui";
import { useState } from "react";
import { AnimateReveal } from "~components/AnimateReveal/AnimateReveal";
import { OrderSummary } from "~features/checkout/common/components/OrderSummary";

export const ExpressCheckoutOrderSummary = () => {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <VStack>
      {isExpanded ? (
        <OrderSummary.OrderSummaryText
          onClick={() => setIsExpanded(false)}
          caretPosition={"down"}
        />
      ) : (
        <OrderSummary.Total
          onClick={() => setIsExpanded(true)}
          caretPosition={"down"}
        />
      )}

      <AnimateReveal show={isExpanded}>
        <VStack gap={2} mt={2}>
          <OrderSummary.EventInfo />

          <VStack gap={1}>
            <OrderSummary.AllLineItemsAndFees />
          </VStack>

          <OrderSummary.Divider />
          <OrderSummary.Total />
        </VStack>
      </AnimateReveal>
    </VStack>
  );
};
